// extracted by mini-css-extract-plugin
module.exports = {"root":"UiRating_root_vaHLK","button":"UiRating_button_lhh8d","isActive":"UiRating_isActive_3KEai","isDisabled":"UiRating_isDisabled_3CzfQ","icon":"UiRating_icon_29qmf"};